import { render, staticRenderFns } from "./EventPresence.vue?vue&type=template&id=38d595f8&"
import script from "./EventPresence.vue?vue&type=script&lang=js&"
export * from "./EventPresence.vue?vue&type=script&lang=js&"
import style0 from "./EventPresence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports